import './PageGeneric.scss'
import './PageGeneric-media.scss';

import {connect, MapDispatchToProps, MapStateToProps, WithStore} from "../../redux/services/Imports";
import Content from "../../components/Content/Content";
import Title from "../../components/Title/Title";
import {AnchorLink} from "react-anchor-navigation";
import Button from "../../components/Button/Button";
import React, {useEffect, useState} from "react";
import {emptyBlock} from "../../services/content/functions";
import {IWordpressBlockCompanyLogos} from "../../services/content/interfaces/blocks/IWordpressBlockCompanyLogos";
import SliderLogos from "../../components/SliderLogos/SliderLogos";
import {
  IWordpressBlockTextCards,
} from "../../services/content/interfaces/blocks/IWordpressBlockTextCards";
import Steps from "../../components/Steps/Steps";
import {BlockTextCards} from "../../components/BlockTextCards/BlockTextCards";
import {Faq} from "../../components/Faq/Faq";
import {IWordpressBlockFaq} from "../../services/content/interfaces/blocks/IWordpressBlockFaq";
import {IWordpressBlockCounters} from "../../services/content/interfaces/blocks/IWordpressBlockCounters";
import Counter from "../../components/Counter/Counter";
import {IWordpressBlockAdvantageSlider} from "../../services/content/interfaces/blocks/IWordpressBlockAdvantageSlider";
import BlockCarousel from "../../components/BlockCarousel/BlockCarousel";
import SliderReviews from "../../components/SliderReviews/SliderReviews";
import {IWordpressBlockReviews} from "../../services/content/interfaces/blocks/IWordpressBlockReviews";
import {IWordpressBlockIconCards} from "../../services/content/interfaces/blocks/IWordpressBlockIconCards";
import {BlockIconCards} from "../../components/BlockIconCards/BlockIconCards";
import {IWordpressBlockBlue} from "../../services/content/interfaces/blocks/IWordpressBlockBlue";
import DescriptionBlock from "../../components/DescriptionBlock/DescriptionBlock";
import {IWordpressBlockDocuments} from "../../services/content/interfaces/blocks/IWordpressBlockDocuments";
import WordpressDocsList from "../../components/DocsList/WordpressDocList";
import {IWordpressBlockCheckList} from "../../services/content/interfaces/blocks/IWordpressBlockCheckList";
import List from "../../components/List/List";
import {IWordpressBlockPvzSchedule} from "../../services/content/interfaces/blocks/IWordpressBlockPvzSchedule";
import CardPVZ from "../../components/CardPVZ/CardPVZ";
import CardCount from "../../components/CardCount/CardCount";
import {IPageContent} from "../../components/App/interfaces";
import {IWordpressBlockPartners} from "../../services/content/interfaces/blocks/IWordpressBlockPartners";
import LogosPartners from "../../components/LogosPartners/LogosPartners";
import {ContactFormType, IWordpressContactForm} from "../../services/content/interfaces/IWordpressContactForm";
import FormContacts from "../../components/FormContacts/FormContacts";
import FormContactsNew from "../../components/FormContactsNew/FormContactsNew";
import FormContactsExtended from "../../components/FormContactsExtended/FormContactsExtended";
import {IWordpressBlockImgtxtBlocks} from "../../services/content/interfaces/blocks/IWordpressBlockImgtxtBlocks";
import BlockImgTxt from "../../components/BlockImgTxt/BlockImgTxt";
import FormContactsMini from "../../components/FormContactsMini/FormContactsMini";
import SliderGallery from "../../components/SliderGallery/SliderGallery";
import {IWordpressBlockGallery} from "../../services/content/interfaces/blocks/IWordpressBlockGallery";

interface Props {
  widthWindow: number;
  offsetContent: number;
  alertLoaded: Function;
  heightLazy: number;
  pageContent: IPageContent;
}

const PageGeneric = ({widthWindow, offsetContent, alertLoaded, heightLazy, pageContent}: Props) => {
  const [widthContent, setWidthContent] = useState('1280px');
  useEffect(() => {
    setWidthContent(widthWindow > 1439 ? '1440px' : '100vw');
  }, [widthWindow]);

  const stylesBlock: { [key: string]: any } = {
    transform: `translateX(-${offsetContent}px) translateY(-${
      widthWindow > 1439 ? '124px' : widthWindow > 720 ? `${124 / 14.4}vw` : '106px'
    })`,
  };
  if (pageContent.header?.background_image) {
    stylesBlock.backgroundImage = `url('${pageContent.header.background_image}')`
  }

  const renderBlock = (name: string) => {
    // @ts-ignore
    if (!(name in pageContent) || !pageContent[name]?.visible) {
      // @ts-ignore
      console.debug('not rendering block', name, 'visibility', pageContent[name]?.visible)
      return emptyBlock;
    }
    // @ts-ignore
    console.debug('rendering block', name, pageContent[name]);
    let data;
    switch (name) {
      case 'header':
        return emptyBlock;
      case 'company_logos':
        data = pageContent[name] as IWordpressBlockCompanyLogos;
        return (
          <Content
            key={name}
            padding={{paddingMain: {top: 160, bottom: 80}, paddingMob: {top: 80, bottom: 40}}}
            block={
              <>
                <Title center title={data.title} marginBottom={40}/>
                <SliderLogos slidesLogo={data.items}/>
              </>}
          />);
      case 'number_cards':
        data = pageContent[name] as IWordpressBlockTextCards;
        return (<Content
          heightLazy={widthWindow > 720 ? 692 : null}
          padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
          block={
            <Steps title={data.title} list={data.items}/>
          }
        />);
      case 'text_cards':
      case 'text_cards2':
        data = pageContent[name] as IWordpressBlockTextCards;
        return (<BlockTextCards textCards={data} heightLazy={null}/>);
      case 'text_cards_3columns':
        data = pageContent[name] as IWordpressBlockTextCards;
        return (
          <Content
            // heightLazy={widthWindow > 720 ? 880 : null}
            padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
            block={
              <>
                <Title center title={data.title}/>
                <div className="page-delivery-pvz__grid-3">
                  {data.items.map((item, i) => (
                    <CardCount idx={i + 1} numberCard={i + 1} text={item.text} noCut height="auto" key={i}/>
                  ))}
                </div>
              </>
            }
          />);
      case 'faq':
        data = pageContent[name] as IWordpressBlockFaq;
        return (<Content
          padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
          block={
            <>
              <Faq title={data.title} className="page-return-documents__quests" items={data.items}
                   expanded={data.expanded}/>
            </>
          }
        />);
      case 'counters':
        data = pageContent[name] as IWordpressBlockCounters;
        return (<Content
          padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
          block={
            <>
              <Title title={data.title} text={data.subtitle} center/>
              <div className="page-about__bg-7"></div>
              <div className="page-about__grid-counts">
                {data.items.map((item, i) => (
                  <Counter {...item} key={i}/>
                ))}
              </div>
            </>
          }
        />);
      case 'advantage_slider':
        data = pageContent[name] as IWordpressBlockAdvantageSlider;
        return (<Content
          width={widthContent}
          padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
          block={<BlockCarousel title={data.title} list={data.slides} noFade={data.no_fade}/>}
        />);
      case 'reviews':
        data = pageContent[name] as IWordpressBlockReviews;
        return (<Content
          padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
          block={<SliderReviews title={data.title} slides={data.items}/>}
        />);
      case 'icon_cards':
        data = pageContent[name] as IWordpressBlockIconCards;
        return (<BlockIconCards iconCards={data} heightLazy={heightLazy}/>);
      case 'blue_block':
      case 'blue_block2':
        data = pageContent[name] as IWordpressBlockBlue;
        return (<Content
          padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
          block={
            <DescriptionBlock
              open
              title={data.title}
              text={data.content}
            />
          }
        />);
      case 'documents':
        data = pageContent[name] as IWordpressBlockDocuments;
        if (!data.groups || !data.groups.length) {
          console.warn('not set documents, ignoring rendering');
          return emptyBlock;
        }
        return (<Content noLazy block={
          <div className="page-docs">{data.groups.map(({title, subtitle, items}) =>
            (<>
              <h3>{title}</h3>
              <h4>{subtitle}</h4>
              <WordpressDocsList list={items.map(({file}) => file)}/>
            </>))}
          </div>}/>);
      case 'check_list':
        data = pageContent[name] as IWordpressBlockCheckList;
        return (<Content
          heightLazy={widthWindow > 720 ? 688 : null}
          padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
          block={
            <>
              <Title center title={data.title}/>
              <div className="page-return-documents__grid-2">
                {data.content.column_1 && <List list={data.content.column_1.map(({text}) => text)} check/>}
                {data.content.column_2 && <List list={data.content.column_2.map(({text}) => text)} check/>}
              </div>
            </>
          }
        />);
      case 'pvz_schedule':
        data = pageContent[name] as IWordpressBlockPvzSchedule;
        return (
          <Content
            heightLazy={widthWindow > 720 ? 1436 : null}
            padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
            block={
              <>
                <Title center title={data.title}/>
                <div className="page-delivery-pvz__grid-3 page-delivery-pvz__mode">
                  {data.items.map((item, i) => (
                    <CardPVZ {...item} key={i}/>
                  ))}
                </div>
              </>
            }
          />);
      case 'partners':
        data = pageContent[name] as IWordpressBlockPartners;
        return (
          <Content
            padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
            block={
              <>
                <Title center title={data.title} marginBottom={40}/>
                <LogosPartners list={data.items}/>
              </>
            }
          />
        );
      case 'contact_form':
      case 'contact_form2':
        data = pageContent[name] as IWordpressContactForm;
        console.log('data', data);
        switch (data.type) {
          case ContactFormType.normal:
            return <Content
              id="form"
              block={<FormContacts eventMetrika={data.metrika_event} sendAmoCRM/>}
              padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
            />;
          case ContactFormType.compact:
            return <Content
              id="form"
              padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
              block={
                <FormContactsNew
                  title={data.title}
                  subTitle={data.sub_title}
                  buttonText={data.button_text}
                  eventMetrika={data.metrika_event}
                  sendAmoCRM
                />
              }
            />;
          case ContactFormType.extended:
            return <Content
              id="form"
              block={<FormContactsExtended eventMetrika={data.metrika_event} buttonText={data.button_text}
                                           title={data.title}/>}
              padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
            />;
          case ContactFormType.mini:
            return <Content
              id="form"
              block={<FormContactsMini eventMetrika={data.metrika_event} buttonText={data.button_text}
                                       title={data.title}/>}
              padding={{paddingMain: {top: 80, bottom: 80}, paddingMob: {top: 40, bottom: 40}}}
            />;
          default:
            return emptyBlock;
        }
      case 'imgtxt_blocks':
        data = pageContent[name] as IWordpressBlockImgtxtBlocks;
        return (
          <Content
            padding={{paddingMain: {top: 80, bottom: 0}, paddingMob: {top: 40, bottom: 40}}}
            block={
              <>
                {data.title && <Title title={data.title} center/>}
                {data.items.map((item, index) => (<BlockImgTxt key={index} {...item}/>))}
              </>
            }
          />
        );
      case 'gallery':
        data = pageContent[name] as IWordpressBlockGallery;
        return (
          <Content
            bgOut={<div className="page-gallery__bg-1"></div>}
            padding={{paddingMain: {top: 0, bottom: 80}, paddingMob: {top: 0, bottom: 40}}}
            block={
              <div className={'gallery'}>
                <SliderGallery title={data.title} slides={data.photos.map(({image}) => image)} countDotsSlides={8}/>
              </div>}
          />
        )
      default:
        return emptyBlock;
    }
  }

  return (<div className="page-delivery-cur page-delivery-spb">
    {pageContent.header?.visible && <Content
        noLazy
        bgInto={<div className="page-delivery-cur__bg" style={stylesBlock}></div>}
        padding={{paddingMain: {top: 0, bottom: 80}, paddingMob: {top: 0, bottom: 44}}}
        block={
          <>
            <div className="breadcrumbs"></div>

            <Title
              h1
              gradient
              title={pageContent.header?.title}
              text={pageContent.header?.text}
            />

            {pageContent.header?.button.visible &&
                <AnchorLink href={pageContent.header.button.link.url} activeClassName="selected">
                    <Button text={pageContent.header.button.link.title}/>
                </AnchorLink>}
          </>
        }
    />}
    {pageContent.order.map(renderBlock)}
  </div>)
}


export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageGeneric));


